/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown> }} Chat_Input_Characters_RemainingInputs */

const es_chat_input_characters_remaining = /** @type {(inputs: Chat_Input_Characters_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quedan ${i?.remaining} caracteres`)
};

const en_chat_input_characters_remaining = /** @type {(inputs: Chat_Input_Characters_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} characters remaining`)
};

/**
* | output |
* | --- |
* | "{remaining} characters remaining" |
*
* @param {Chat_Input_Characters_RemainingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_input_characters_remaining = /** @type {((inputs: Chat_Input_Characters_RemainingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Input_Characters_RemainingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_input_characters_remaining(inputs)
	return en_chat_input_characters_remaining(inputs)
});
export { chat_input_characters_remaining as "chat.input_characters_remaining" }